import React from 'react'

interface IProps<T> {
  value: T
  options: T[]
  onChange: (value: T) => void
  renderOption: (option: T) => React.ReactNode
  className?: string
}

function ToggleButtonGroup<T>({
  value,
  options,
  onChange,
  renderOption,
  className,
}: IProps<T>) {
  return (
    <div className={`toggle-group${className ? ` ${className}` : ''}`}>
      {options.map((option, index) => (
        <React.Fragment key={index}>
          {index > 0 &&
            options.length > 2 &&
            options[index - 1] !== value &&
            option !== value && <div className="toggle-group_sep" />}
          <button
            type="button"
            className={`clear-button toggle-group_btn${value === option ? ' -active' : ''}`}
            onClick={() => onChange(option)}
          >
            {renderOption(option)}
          </button>
        </React.Fragment>
      ))}
    </div>
  )
}

export default ToggleButtonGroup
